module.exports = __webpack_public_path__ + "static/media/university-limerick.67103b93.png";